import { TranslationMessages } from 'react-admin';
import deutschMessages from 'ra-language-german';

const customDeutschMessages: TranslationMessages = {
  ...deutschMessages,
  pos: {
    title: "Kundenlogin",
    companyLabel: "ihr-unternehmen",
    submitButton: "weiter",
  }
}

export default customDeutschMessages;
